
import { defineComponent, ref } from 'vue'
import { useRouter, useRoute } from 'vue-router'
import { useStore } from 'vuex'
import { NuxeoOrderResponse } from '@/contracts/api/ResponseContracts'
import { NuxeoOrderRequest } from '@/contracts/api/RequestContracts'
import { nuxeoOrderComplete } from '@/composables/nuxeo'

export default defineComponent(
{
    name: 'PaySuccess',
    setup()
    {
        // Load router:
        const router = useRouter()
        const route = useRoute()
        // Use vuex:
        const store = useStore()
        // Get authentication status:
        const isAuthenticated = store.getters['auth/isAuthenticated']
        const authenticatedUser = store.getters['auth/getUser']
        // Get basket from store:
        const basketItems = store.getters['basket/getBasket']
        // Generate array of uid's to process:
        const uids = [] as Array<string>
        for(let i = 0; i < basketItems.length; i++)
        {
            uids.push(basketItems[i].uid)
        }

        // Set params for order query:
        const orderParams =
        {
            orderItems: JSON.stringify(uids),
            customerName: authenticatedUser.id,
            customerEmail: authenticatedUser.email.toLowerCase(),
            status: 'success'
        } as NuxeoOrderRequest

        // Set payment data keys:
        const orderDataKeys = ref(0)
        // Set order data into order params:
        if(route.query.orderID !== undefined && route.query.orderID !== null)
        {
            orderParams.paymentID = route.query.orderID.toString()
            orderDataKeys.value++
        }
        if(route.query.BRAND !== undefined && route.query.BRAND !== null)
        {
            orderParams.cardBrand = route.query.BRAND.toString()
            orderDataKeys.value++
        }
        if(route.query.PM !== undefined && route.query.PM !== null)
        {
            orderParams.cardTypeOf = route.query.PM.toString()
            orderDataKeys.value++
        }
        if(route.query.TRXDATE !== undefined && route.query.TRXDATE !== null && route.query.TRXDATE !== '')
        {
            const orderDataArray = route.query.TRXDATE.toString().split('/')
            orderParams.settledDate = '20' + orderDataArray[2] + '-' + orderDataArray[0] + '-' + orderDataArray[1]
            orderDataKeys.value++
        }
        else
        {
            const today = new Date()
            orderParams.settledDate = today.getUTCFullYear() + '-' + ((today.getUTCMonth() + 1) < 10 ? '0' : '') + (today.getUTCMonth() + 1) + '-' + (today.getUTCDate() < 10 ? '0' : '') + today.getUTCDate()
            orderDataKeys.value++
        }

        console.log(orderParams)

        // Check for items:
        if(JSON.parse(orderParams.orderItems).length === 0)
        {
            // Display error:
            store.commit('errors/setNuxeoErrors',
            {
                message: 'Error occurred trying to complete order. Order items are missing. Your order number is: ' + (orderParams.paymentID !== undefined ? orderParams.paymentID : '')
            })
            router.push({ hash: '#error-summary-container' })
        }
        // Check for order data parmas:
        else if(orderDataKeys.value < 4)
        {
            // Display error:
            store.commit('errors/setNuxeoErrors',
            {
                message: 'Error occurred trying to complete order. Order parameters are missing. Your order number is: ' + (orderParams.paymentID !== undefined ? orderParams.paymentID : '')
            })
            router.push({ hash: '#error-summary-container' })
        }
        else
        {
            // Record order:
            nuxeoOrderComplete(
            authenticatedUser.id,
            authenticatedUser.password,
            orderParams,
            function(response: NuxeoOrderResponse)
            {
                // Remove from basket:
                store.commit('basket/resetBasket')
                // Show success:
                store.commit('confirmations/setConfirmationData',
                {
                    title: 'Order complete',
                    body: 'Your payment was successful. Your order has been accepted.'
                })
                router.push({ hash: '#confirmation-summary-container' })
            },
            [
                {
                    code: 500,
                    error: '500 returned - please contact your administrator',
                    message: 'Error occurred trying to complete order. Please contact your administrator. Your order number is: ' + (orderParams.paymentID !== undefined ? orderParams.paymentID : '')
                }
            ])
        }

        // Return data:
        return {
            isAuthenticated,
            orderDataKeys
        }
    }
})
